import template from 'facets/category-sort-by-outer-mobile.j2';
import { dDom } from '../../../core/js/utils/renderUtils';

import { generate } from '../../../core/js/utils/componentUtils';

import {
    sortCategory
} from '../actions/sortActions';

export function forceRender() {
    $.each($(this.componentLocation).find('input'), (index, input) => {
        $(input).prop('disabled', false);
    });
}

/**
 * Attach component events to DOM
 * @param {object} store - The store
 * @returns {undefined}
 */
export function attachEvents(store) {
    $(document).on('change', 'input[type=radio][name=sortOption]', (e) => {
        $(e.target).blur();
        this.attachLoader(store);
        const qs = e.target.value;

        const categoryId = store.getState().category.categorySlug;

        store.dispatch(sortCategory(categoryId, qs, e));
    });

    $(document).on(`touchend.${this.templateLocation} click.${this.templateLocation}`, '.js-sort-default', (e) => {
        e.preventDefault();
        if (_.isNull(_.get(store.getState(), 'category.sortOptions.selectedSort', null))) {
            return false;
        }
        this.attachLoader(store);
        const el = $(e.currentTarget);
        const qs = el.attr('data-clear-query');

        const categoryId = store.getState().category.categorySlug;

        store.dispatch(sortCategory(categoryId, qs, e));
    });
}

export function onStateChange(store) {
    this.render(store, this, {}, store);
}

export function afterRender(store) {
    this.removeLoader(store);
}

/**
 * Bootstrap the component onto the page
 * @param {object} store - The store
 * @param {object} overrides - The overrides object
 * @returns {undefined}
 */
export function init(store, overrides = {}) {
    let config = {
        children: [],
        templateLocation: '.dom-sort-by-mobile',
        watch: 'category.queryString',
        name: 'mobileSortComponent',
        attachEvents: attachEvents,
        onStateChange: onStateChange,
        template: template,
        afterRender: afterRender,
        firstRender: forceRender,
        onStateChnage: onStateChange,
        renderType: dDom
    };

    return generate(config, store, overrides);
}
